/** This is a Container.  Place all code
 * portions that deal with the server
 * or Redux in this file.  It is not
 * for handling display templates */

import { connect } from 'react-redux';
import * as actions from './ProjectedCashFlowReportActions';
import ProjectedCashFlowReportView from './ProjectedCashFlowReportView';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => {
  let subdivision = state.ProjectedCashFlowReport[ownProps.clientId];

  return {
    clientId: ownProps.clientId,
    error_type: subdivision ? subdivision.error_type : null,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    errors: subdivision ? subdivision.errors : null,
    is_current: subdivision ? subdivision.is_current : ownProps.is_current,
    periods: subdivision ? subdivision.Periods : [],
    principalAges: subdivision ? subdivision.PrincipalAges : [],
    spouseAges: subdivision ? subdivision.SpouseAges : [],
    people: subdivision ? subdivision.People : [],
    inflows: subdivision ? subdivision.Inflows : [],
    inflowsTotals: subdivision ? subdivision.InflowsTotals : [],
    outflows: subdivision ? subdivision.Outflows : [],
    outflowsTotals: subdivision ? subdivision.OutflowsTotals : [],
    milestones: subdivision ? subdivision.Milestones : [],
    netCashflow: subdivision ? subdivision.NetCashflow : [],
    mode: subdivision ? subdivision.Mode : [],
    isPrint: ownProps.isPrint,
    fpId: ownProps.fpId,
    portalName: selectPortalName(state),
    title: ownProps.title,
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data(mode, clientId, fpId, IsPdf, expandCurrentYear) {
    dispatch(actions.fetch_data(mode, clientId, fpId, IsPdf, expandCurrentYear));
  },
  set_current(clientId) {
    dispatch(actions.set_current(true, clientId));
  },
  set_projected(clientId) {
    dispatch(actions.set_current(false, clientId));
  },
});

const ProjectedCashflowReport = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectedCashFlowReportView);

export default ProjectedCashflowReport;
